module.exports = __webpack_public_path__ + "static/media/ic-x.28bc574a.svg";